import React from 'react'

import SelectGenericValueEmpty from "./value/value-empty"
import SelectGenericValueNotEmpty from "./value/value-not-empty"
import SelectGenericPopoverMenu from "./popover/popover-menu"

const debug = false
// const debug = "SelectGenericNew"

type Props = {
    className?                      : string
    options                         : Options
    value                           : any

    valueClasses?                   : string    // classes assigned to empty/not empty selector view components

    placeholder?                    : string
    noValueOptionLabel?             : string

    popoverContainerClasses?        : string
    popoverClasses?                 : string
    popoverScrollContainerClasses?  : string

    noValueOption?                  : boolean   // is all values option available
    noValueOptionNoAccent?          : boolean   // show no value option as placeholder (ui5-txt-no-accent-default)
    isSearchable?                   : boolean   // is used in popover
    disabled?                       : boolean
    scrollToSelected?               : boolean

    valueComponent?                 : any
    popoverOptionComponent?         : any

    valueEmptyComponent?            : callback
    iconComponent?                  : callback  // is used in default SelectMultiGenericValueEmpty component

    onChange                        : callback
}

export default class SelectGenericNew extends React.Component<Props,any> {

    public previousOption   : any
    public currentOption   : any

    static defaultProps = {
        placeholder             : 'Please select',
        noValueOption           : false,
        noValueOptionLabel      : 'None',
        scrollToSelected        : true
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            initialPropsValue   : props.value,
            currentOption       : _.find(props.options, option => option.value === props.value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        if (props.value !== state.initialPropsValue) {
            return {
                initialPropsValue   : props.value,
                currentOption       : _.find(props.options, option => option.value === props.value),
            }
        }
        return null
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        this.previousOption = this.state.currentOption

        let currentOption:any
        if (!!option.isNoValueOption) {
            currentOption = null
        } else {
            currentOption = option
        }

        this.setState({
            currentOption   : currentOption,
            showPopover     : false,
        }, () => {
            if (this.props.onChange) this.props.onChange(currentOption, this.onCancelChange)
        })
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.currentOption
        })
    }

    _getValueComponent = (selectedOption:any) => {
        let ValueComponent

        if (!!selectedOption) {
            ValueComponent = this.props.valueComponent || SelectGenericValueNotEmpty
        } else {
            ValueComponent = this.props.valueEmptyComponent || SelectGenericValueEmpty
        }

        return ValueComponent
    }

    render() {
        const classes: string = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'disabled'      : this.props.disabled
        })

        let ValueComponent = this._getValueComponent(this.state.currentOption)

        debug && console.log(debug, "render", this.props.placeholder, this.state.currentOptions, this.state.currentOption)

        return (
            <ValueComponent className               = {classes}
                            valueClasses            = {this.props.valueClasses}
                            placeholder             = {this.props.placeholder}
                            noValueOption           = {this.props.noValueOption}
                            noValueOptionNoAccent   = {this.props.noValueOptionNoAccent}
                            noValueOptionLabel      = {this.props.noValueOptionLabel}
                            iconComponent           = {this.props.iconComponent}
                            option                  = {this.state.currentOption}
                            onClick                 = {!this.props.disabled ? this.showPopover : null}
                            onDelete                = {!this.props.disabled ? this.onOptionClick : null}>

                {this.state.showPopover && <SelectGenericPopoverMenu parent                         = {this}
                                                                     options                        = {this.props.options}
                                                                     noValueOptionLabel             = {this.props.noValueOptionLabel}
                                                                     noValueOption                  = {this.props.noValueOption}
                                                                     popoverContainerClasses        = {this.props.popoverContainerClasses}
                                                                     popoverClasses                 = {this.props.popoverClasses}
                                                                     popoverScrollContainerClasses  = {this.props.popoverScrollContainerClasses}
                                                                     isSearchable                   = {this.props.isSearchable}
                                                                     popoverOptionComponent         = {this.props.popoverOptionComponent}/>}
            </ValueComponent>
        )
    }
}
